const MODAL_CLOSE_BOX_THEMES = {
  light: 'light',
  dark: 'dark',
}

export { MODAL_CLOSE_BOX_THEMES }
